var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "16px",
    viewBox: "0 0 10 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52755 15.8543C4.59506 15.9459 4.70211 16 4.81592 16C4.92974 16 5.03678 15.9459 5.10429 15.8543C5.15044 15.7916 6.24739 14.2961 7.36151 12.1872C8.868 9.33567 9.63184 6.8556 9.63184 4.81592C9.63184 2.16042 7.47143 0 4.81592 0C2.16042 0 0 2.16042 0 4.81592C0 6.8556 0.763837 9.33567 2.27034 12.1872C3.38445 14.2961 4.48141 15.7916 4.52755 15.8543ZM0.716419 4.81592C0.716419 2.55544 2.55544 0.716419 4.81592 0.716419C7.0764 0.716418 8.91542 2.55544 8.91542 4.81592C8.91542 6.70836 8.16076 9.13834 6.73302 11.8432C6.1538 12.9366 5.51386 13.9968 4.8162 15.0188C3.83943 13.5912 0.716419 8.72062 0.716419 4.81592ZM1.59204 4.81592C1.59204 6.59356 3.03828 8.0398 4.81592 8.0398C6.59356 8.0398 8.0398 6.59357 8.0398 4.81592C8.0398 3.03828 6.59356 1.59204 4.81592 1.59204C3.03828 1.59204 1.59204 3.03828 1.59204 4.81592ZM2.30846 4.81592C2.30846 3.4333 3.4333 2.30846 4.81592 2.30846C6.19854 2.30846 7.32338 3.4333 7.32338 4.81592C7.32338 6.19854 6.19854 7.32338 4.81592 7.32338C3.4333 7.32338 2.30846 6.19854 2.30846 4.81592Z",
    id: "Combined-Shape",
    fill: "#666666",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoGrey);
export default __webpack_public_path__ + "static/media/geo-grey.6146e32b33f7f980d6f4565b7bf396f5.svg";
export { ForwardRef as ReactComponent };